import { useEffect, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, InputLabel, RadioButton, RadioGroup } from '@hopskipdrive/react-components';

import { useReportsQuery } from '../../../hooks/useReportsQuery';

import { GroupByRow } from './CustomReportForm.styles';

export const GroupByToggle = () => {
  const { control, watch, setValue } = useFormContext();
  const { staticFilters } = useReportsQuery();

  const [riders, groupBy] = watch(['riders', 'groupBy']);
  const hasSharedRidersSelected = useMemo(() => riders?.some((rider) => rider.value === 'shared_riders'), [riders]);

  useEffect(() => {
    if (groupBy === 'residence_district' && !hasSharedRidersSelected) {
      setValue('groupBy', '');
    }
  }, [riders]);

  return (
    <GroupByRow>
      <InputLabel htmlFor="groupBy">Group By</InputLabel>
      <Controller
        control={control}
        name="groupBy"
        defaultValue={'none'}
        render={({ field: { onChange, value } }) => (
          <RadioGroup row onChange={onChange} value={value}>
            {staticFilters?.groupBy.map((filter, index) => (
              <FormControlLabel
                value={filter.value}
                control={<RadioButton />}
                label={filter.label}
                key={index}
                data-testid={`${filter.label.replaceAll(' ', '-').toLowerCase()}-group`}
                disabled={filter.value === 'residence_district' && !hasSharedRidersSelected}
                aria-label={`Group by ${filter.label}`}
              />
            ))}
          </RadioGroup>
        )}
      />
    </GroupByRow>
  );
};
